import { FamilyStepOption } from "@domain/product/monitoring/family/family-step-option";
import { FamilyStepOptionDto } from "@lib/dtos/monitoring/family/family-step-option.dto";
import { Type } from "class-transformer";
import { IsInstance, IsNumber, Min, ValidateNested } from "class-validator";

export class MonitoringProductItem {
  @IsInstance(FamilyStepOptionDto)
  @Type(() => FamilyStepOptionDto)
  @ValidateNested()
  option: FamilyStepOption;

  @IsNumber()
  @Min(1, { message: "Quantity must be greater than 0" })
  quantity: number;

  constructor(option: FamilyStepOption, quantity: number) {
    this.option = option;
    this.quantity = quantity;
  }

  static create(option: FamilyStepOption, quantity = 1): MonitoringProductItem {
    return new MonitoringProductItem(option, quantity);
  }

  static buildDeviceQuantityMap(items: MonitoringProductItem[] = []): Map<string, number> {
    const quantities = new Map<string, number>();

    items.forEach((item) => {
      const quantity = item?.quantity ?? 1;
      item?.option?.devices?.forEach((device) => {
        const current = quantities.get(device) ?? 0;
        quantities.set(device, current + quantity);
      });
    });

    return quantities;
  }
}
